import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '@services/app-configuration.service';
import { AppLoggerService } from '@services/app-logger.service';
import { standardRoutes, formRoutes } from 'src/app/routes-config/route-config';

export function pathFunctions(path, _debug = false) {
  const [, modulePath, componentPath] = path.split('/');
  const moduleName = Object.keys(formRoutes).find(module => formRoutes?.[module].path === modulePath);
  if (!moduleName) {
    return null;
  }
  const moduleForms = formRoutes?.[moduleName]?.childForms || [];
  const moduleFormsNames = Object.keys(moduleForms);
  const componentName = moduleFormsNames.find(formName => moduleForms[formName].route === componentPath);
  return moduleForms[componentName]?.functions;
}

export function formRoute(formCode, debug = false, logger?: AppLoggerService) {
  const formName = standardRoutes?.[formCode] ?? formCode;
  if (!formName) {
    return;
  }
  let moduleRoute = '';
  let pageRoute = '';
  if (formName) {
    const moduleNames = Object.keys(formRoutes);
    for (const moduleName of moduleNames) {
      moduleRoute = formRoutes?.[moduleName]?.path ?? '';
      const moduleForms = formRoutes?.[moduleName]?.childForms ?? [];
      if (formName in moduleForms) {
        pageRoute = moduleForms[formName].route ?? '';
        break;
      }
    }
  }
  if (!moduleRoute || !pageRoute) {
    debug && logger?.debug(`No logramos encontrar ${formName}`);
    return '';
  }
  return `${moduleRoute}/${pageRoute}`;
}

export function fullRouteForm(route, _debug = false): any {
  return {};
}

export function routeForm(route, debug = false) {
  const { formCode } = fullRouteForm(route, debug);
  return formCode;
}

export function moduleRoot(moduleName) {
  return formRoutes?.[moduleName]?.path ?? '';
}

@Injectable({
  providedIn: 'root',
})
export class ComponentPageService {
  private _appConfig = inject(AppConfigService);

  private logger = inject(AppLoggerService);

  pathFunctions(path) {
    const debug = this._appConfig.getParameter('debug');
    return pathFunctions(path, debug);
  }

  formRoute(formName) {
    const debug = this._appConfig.getParameter('debug');
    return formRoute(formName, debug, this.logger);
  }

  routeForm(route) {
    const debug = this._appConfig.getParameter('debug');
    return routeForm(route, debug);
  }
}
